module.exports = __webpack_public_path__ + "202c92135e5ed157882002f842a07a39.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-thin.woff
// module id = 80
// module chunks = 0